(() => {
  const getViennaProcessingDate = (now = new Date()) => {
    const todayParts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Vienna',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(now);
    const parts = Object.fromEntries(todayParts.map(({ type, value }) => [type, value]));
    const dateKey = `${parts.year}-${String(parts.month).padStart(2, '0')}-${String(parts.day).padStart(2, '0')}`;
    const tomorrow = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day) + 1, 12));
    const label = new Intl.DateTimeFormat('de-AT', {
      timeZone: 'Europe/Vienna',
      day: '2-digit',
      month: '2-digit'
    }).format(tomorrow);
    return { dateKey, text: `morgen, ${label}` };
  };

  const updateProcessingDate = (root) => {
    const dateNode = root.querySelector('[data-melbourne-emma-processing-date]');
    if (!dateNode) return;
    try {
      const nextDate = getViennaProcessingDate();
      if (dateNode.dataset.melbourneEmmaDateKey === nextDate.dateKey && dateNode.textContent === nextDate.text) return;
      dateNode.dataset.melbourneEmmaDateKey = nextDate.dateKey;
      dateNode.textContent = nextDate.text;
    } catch (_) {
      dateNode.textContent = 'morgen';
      delete dateNode.dataset.melbourneEmmaDateKey;
    }
  };

  const refresh = () => {
    document.querySelectorAll('[data-melbourne-emma-pdp]').forEach(updateProcessingDate);
  };

  if (typeof module !== 'undefined' && module.exports) module.exports = { getViennaProcessingDate };

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', refresh, { once: true });
    } else {
      refresh();
    }
    window.addEventListener('pageshow', refresh);
    document.addEventListener('shopify:section:load', refresh);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) refresh();
    });
    window.setInterval(refresh, 60000);
  }
})();
